<script>
    import { handleSwitchClick } from '../store.js';

    export let name
    export let instruction
    let aantal

    let isSelected = false;
    function toggleCheck(e) {
        handleSwitchClick(name, e.target.checked, aantal = 1);       
    isSelected = !isSelected
    };
</script>
{#if instruction}

<label for={name} class:selected="{isSelected === true}">
    <input type="checkbox" name={name} id={name} on:click={toggleCheck} >
    <span>{name}</span>
    {#if instruction}
    <p>{instruction}</p>
    {/if}
</label>

{:else}

<label for={name} class:selected="{isSelected === true}">
    <span>{name}</span>
    <input type="checkbox" name={name} id={name} on:click={toggleCheck} >
</label>
{/if}


<style>
    label {
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: left;
        padding: 20px;
        background: rgba(0,63,49,.1);
        border: 1px solid transparent;
        transition: all .3s ease-in;
        border-radius: 8px;
    }

    label:hover {
        cursor: pointer;
        background-color: rgba(0,63,49,.08);
    }

    label:hover input[type=checkbox]:not(:checked)::after {
        left: 6px;
    }
    
    label.selected {
        background: white;
        border: 1px solid #CA1E22;
    }

    label span {
        font-size: 16px;
        font-weight: 700;
        font-family: 'Poppins',Helvetica,Arial,Lucida,sans-serif;
        color: #003f31;
    }
    input[type=checkbox] {
        appearance: none;
        margin: 0;
        position: absolute;
        width: 40px;
        height: 20px;
        border-radius: 20px;
        background: rgba(0,63,49,.15);
        top: 10px;
        right: 10px;
    }
    input[type=checkbox]::after {
        content: '';
        position: absolute;
        width: 14px;
        height: 14px;
        border-radius: 14px;
        top: 3px;
        left: 3px;
        transition: all .3s ease;
        background-color: white;
    }
    input[type=checkbox]:checked {
        background: #CA1E22;
    }

    input[type=checkbox]:checked::after {
        left: 22px;
    }

</style>